





















import { Vue, Component } from "vue-property-decorator";
import { changePassword } from "@/api/h5/index";
import { Cell, Toast, Icon, Form, Field, Button, Loading } from "vant";

@Component({
  components: {
    [Cell.name]: Cell,
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button,
    [Loading.name]: Loading,
    [Icon.name]: Icon,
  },
})
export default class empowermentQueryComponent extends Vue {
  loading = false;
  changeReq = {
    password: "",
  };
  created() {
  
  }
  mounted() {}
  goBack() {
    this.$router.push("personal");
  }
  onSubmit() {
    this.loading = true;
    changePassword(this.changeReq)
      .then((res) => {
        const { data, success, message } = res;
        if (success) {
          Toast.success("修改成功！");
          this.$router.push("personal");
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }
  onFailed(errorInfo: any) {
    if (errorInfo.errors.length > 0) {
      Toast("请填写完整星号内容！");
    }
  }
}
